import Collection from "lib/collection";
import ShippingInfoEntryModel from "../models/payments/shipping-info-entry";

export default Collection.extend({
    model: ShippingInfoEntryModel,
});
